import type { Component } from 'vue'
import type { Menu } from '~/types/models/menu'
import { HeaderMenuColumnMenuItem, HeaderMenuStaticUrlMenuItem, HeaderMenuTextMenuItem } from '#components'
import { useConfigStore } from '~/store/useConfigStore'

export const useMenu = () => {
  const components = {
    'text': HeaderMenuTextMenuItem,
    'static-url': HeaderMenuStaticUrlMenuItem,
    'column': HeaderMenuColumnMenuItem,
  }

  const resolveComponentsForMenuItem = (menuItem: Menu.MenuItem) => {
    const result: Menu.MenuItem & { component?: Component } = {
      ...menuItem,
      analyticsId: menuItem.data?.['analytics_id'] || `menu-item-${menuItem.id}`,
      component: undefined,
    }

    const component = components[menuItem.type] || undefined

    if (component) {
      result.component = component
    }

    if (menuItem.children.length > 0) {
      result.children = menuItem.children.map(childrenMenuItem => resolveComponentsForMenuItem(childrenMenuItem))
    }

    return result
  }

  const resolveMenuBySlug = (slug: Menu.MenuSlug): undefined | Menu.Model => {
    const config = useConfigStore()

    const menu = config.$state.menus.find(menu => menu.slug === slug)

    if (!menu) {
      return undefined
    }

    return {
      ...menu,
      menuItems: menu.menuItems.map(menuItem => resolveComponentsForMenuItem(menuItem)),
    }
  }

  return { resolveMenuBySlug, resolveComponentsForMenuItem }
}
